import { render, staticRenderFns } from "./MyPrescribeDetail.vue?vue&type=template&id=9f4cf328"
import script from "./MyPrescribeDetail.vue?vue&type=script&lang=js"
export * from "./MyPrescribeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports